/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createFlatten } from '../../factoriesAny.js';
export var flattenDependencies = {
  matrixDependencies,
  typedDependencies,
  createFlatten
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesFlatten.generated.js
// module id = 219
// module chunks = 2